export default __webpack_public_path__ + "static/media/instagram-fill1.fca6defc.svg";